import React, { useEffect, useState } from 'react'
import { MP_PK_SANDBOX as MP_PK } from '../../services/constantes'
import { Payment, usePaymentBrick, StatusScreen, initMercadoPago } from '@mercadopago/sdk-react';
import { Button, Flex } from 'antd';
import { useToasts } from 'react-toast-notifications';



export const PaymentCtrl = (props) => {

    const { addToast } = useToasts()

    useEffect(() => {
        initMercadoPago(MP_PK, { locale: 'pt-BR' });
    }, [])


    async function onSubmit({ selectedPaymentMethod, formData }) {
        //   console.log(selectedPaymentMethod, formData)
    }

    async function onError(error) {
        console.log(error.message)
    };
    async function onReady() {
        //  setLoadingPayment(false)
    };



    return <Flex vertical>
        <Payment
            id='MPLEODELIVERY'
            customization={
                {
                    paymentMethods: {
                        creditCard: "all",
                        bankTransfer: "pix",
                        maxInstallments: 1,
                    },
                    visual: {
                        hideFormTitle: false,
                        hidePaymentButton: true,

                    }

                }
            }

            onSubmit={onSubmit}
            onReady={onReady}
            onError={onError}
            initialization={{
                amount: props.amount
            }}
        />

        <Button 
        type='primary'
        onClick={async() => {
            window.paymentBrickController.getFormData()
                .then(async ({formData, selectedPaymentMethod} ) => {
                     console.log(formData, selectedPaymentMethod)
                    if (formData) {
                        console.log(formData)
                        props.setPaymentOnline(formData, selectedPaymentMethod)
                        props.setOpenPaymentOnline(false)
                    } else {
                      //  addToast("Complete as informações do pagamento", { appearance: 'warning', autoDismiss: true })
                    }
                })
                .catch((error) => {
                  //  addToast(error.message, { appearance: 'error', autoDismiss: true })
                    // error handling when calling getFormData()

                });
        }}>
            Selecionar
        </Button>

    </Flex>
}

export default PaymentCtrl
